<template>
  <BizFiveXCreditsBanner
    :base-u-r-l="baseURL"
    :http="psHttp"
    :locale="locale"
    :enabled="isBannerEnabled"
    @click="handleBannerClick"
  />
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import psHttp from '@patsnap/common-ps-http';
import { controlDeferred } from '@eureka/utils/control';
import { clientDeferred } from '@eureka/utils/client';
import { accountDeferred, isUserLogin } from '@eureka/utils/account';
import { FiveXCreditsBanner as BizFiveXCreditsBanner } from '@patsnap-biz/five-x-credits-banner';
import '@patsnap-biz/five-x-credits-banner/lib/style';
import { DeployEnv } from '@patsnap-utils/biz';
import { REGION } from '@eureka/utils/environment';
import { upgradeTrackingAndRedirect } from '@/composables/tracking/upgrade-tracking';

const { locale } = useI18n() as any;

const baseURL = import.meta.env.VITE_EUREKA_SERVICE_URI;
const isBannerEnabled = ref(false);
const isCompany = ref(false);

async function initBannerEnabled() {
  const account = await accountDeferred.promise;
  const isOversea = [DeployEnv.US, DeployEnv.EU, DeployEnv.STAGE].includes(REGION);
  const [{ freemium }, { isFeiShu }, loggedIn] = await Promise.all([
    controlDeferred.promise,
    clientDeferred.promise,
    isUserLogin(),
  ]);
  isCompany.value = !!account._info?.company_id;
  isBannerEnabled.value = !!freemium && loggedIn && !isFeiShu && isOversea && !isCompany.value;
}

onBeforeMount(async () => {
  await initBannerEnabled();
});

function handleBannerClick() {
  upgradeTrackingAndRedirect('five_x_credits_banner');
}
</script>
